import React from 'react'
import logo50 from './../images/logo50.jpg'
import logo40 from './../images/logo40.jpg'
import logo24 from './../images/logo24.jpg'

export default props => (
  <div className={`c-avatar ${props.modifierClasses}`}>
    <img 
      src={(props.modifierClasses === 'c-avatar--as-author') ? logo40 : logo50} 
      alt="author"
    />
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Avatar.jsx